export default "__VITE_ASSET__cd89ccb3__"